import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { helpers } from 'styles'

export const Container = styled.div`
	background-color: ${helpers.color.textContrast};
	overflow-wrap: break-word;
	border-radius: ${helpers.borderRadius};
	padding: ${helpers.spacing.large};
	box-shadow: 0px 1px 4px 0px ${helpers.color.cardShadow};

	${mobileMediaQuery(css`
		box-shadow: none;
		padding: ${helpers.spacing.large};
	`)}
`
